import React, { FC, memo } from 'react';
import { useI18n } from '~Hooks';
import checkIcon from '../../../../Assets/icons/check.svg';
import arrowBackIcon from '../../../../Assets/icons/arrow_back.svg';
import StepFrame from './StepFrame';
import ChoiceButton from './ChoiceButton';

interface Props {
  /** The shopper accepts that ID may be checked - the checkout goes on. */
  onContinue: () => void;
  /** The shopper backs out - Menu comes back. */
  onBack: () => void;
}

/** "18 or older?" - shown first whenever the cart holds an age-restricted line. */
const LegalAgeStep: FC<Props> = ({ onContinue, onBack }) => {
  const { i18n } = useI18n();

  return (
    <StepFrame
      testId="epos-legal-age-step"
      title={i18n('Express.Checkout.LegalAge.Title')}
      subtitle={i18n('Express.Checkout.LegalAge.SubTitle')}
      actions={
        <>
          <ChoiceButton
            label={i18n('Express.Checkout.LegalAge.Back')}
            icon={arrowBackIcon}
            onClick={onBack}
            testId="epos-legal-age-back"
          />
          <ChoiceButton
            primary
            label={i18n('Express.Checkout.LegalAge.Continue')}
            icon={checkIcon}
            onClick={onContinue}
            testId="epos-legal-age-continue"
          />
        </>
      }
    />
  );
};

export default memo(LegalAgeStep);
